<template>
  <div>
    <div>
      <div class="tasks-title-box w-100 rounded">
        <v-row class="ma-5">
          <v-col class="my-auto mx-auto mobile-d-none"><h3>پیام ها</h3></v-col>
          <v-spacer></v-spacer>
          <v-col class="text-left" xs="12">
            <v-text-field label="جست و جو کنید"
                          placeholder="حداقل ۳ حرف "
                          dense outlined dir="ltr"
                          v-model="search_field"
                          class="search-tasks"
                          clearable
                          @click:clear="search_field=null;get_contacts()"
                          @keydown.enter="page=1;get_contacts()"
                          :rules="[rules.min_3]"
                          style="margin-bottom: -25px"
            >
              <template v-slot:append v-if="search_field && search_field.length>=3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" v-bind="attrs" v-on="on" @click="page=1;get_contacts()"> mdi-magnify </v-icon>
                  </template>
                  <span>
                    برای جست و جو کلیک کنید.
                  </span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="last-changes rounded-lg container">
      <h2 class="text-center mb-3">پیام های دریافت شده</h2>
        <v-data-table
            dense
            :loading="loading_tickets"
            hide-default-footer
            :headers="contacts_table.headers"
            :items="contacts_table.desserts"
            @click:row="handler_click_row"
            style="cursor: pointer"
            class="elevation-0"
        >

          <template v-slot:item.is_read="{ item }">
            <v-chip class="lighten-5 my-4" :color="item.is_read?'success':'red'">
              <v-icon :color="item.is_read?'success':'red'">{{ item.is_read ? 'mdi-check' : 'mdi-close' }}</v-icon>
            </v-chip>
          </template>

          <template v-slot:item.msg="{ item }">
            <v-tooltip v-if="item.msg.length>50" top color="gray" max-width="50em">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs"
                   v-on="on">
                  {{item.msg.slice(0,30)+'...'}}
                </div>
              </template>
              {{item.msg}}
            </v-tooltip>
            <div v-else>
              {{item.msg}}
            </div>
          </template>

        </v-data-table>
      <v-pagination
          v-if="contacts_count > 10"
          v-model="page"
          color="#D20003"
          rounded
          @input="get_contacts()"
          :length="contacts_count%10!==0?parseInt(contacts_count/10)+1:parseInt(contacts_count/10)"
          :total-visible="7"
      ></v-pagination>
      </div>
    <v-dialog v-model="show_detail"
              scrollable
              persistent
              max-width="600"
    >
      <v-card>
        <v-card-title class="mb-5 w-100 text-left">
          <h3>پیام دریافتی از
            '{{`${contact_detail.f_name} ${contact_detail.l_name}`}}'
          </h3>
          <v-spacer></v-spacer>
            <svg @click="show_detail=false;" width="44" height="44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="44" height="44" rx="22" class="back-btn"/>
              <path d="M28.6665 22.2285C28.6665 22.5449 28.4314 22.8064 28.1263 22.8478L28.0415 22.8535L15.5415 22.8535C15.1963 22.8535 14.9165 22.5737 14.9165 22.2285C14.9165 21.9121 15.1516 21.6506 15.4567 21.6092L15.5415 21.6035L28.0415 21.6035C28.3867 21.6035 28.6665 21.8833 28.6665 22.2285Z" fill="black"/>
              <path d="M21.024 26.8059C21.2686 27.0495 21.2695 27.4452 21.0259 27.6898C20.8045 27.9122 20.4573 27.9331 20.2122 27.7521L20.142 27.6917L15.1004 22.6717C14.8773 22.4497 14.857 22.1012 15.0395 21.8562L15.1003 21.786L20.142 16.7652C20.3866 16.5216 20.7823 16.5224 21.0259 16.767C21.2473 16.9893 21.2667 17.3366 21.0847 17.5809L21.024 17.6509L16.4273 22.2291L21.024 26.8059Z" fill="black"/>
            </svg>
        </v-card-title>
        <v-card-text class="container">
          <v-row>
            <v-col cols="6">
              نام :
              {{contact_detail.f_name}}
            </v-col>
            <v-col cols="6">
              نام خانوادگی :
              {{contact_detail.l_name}}
            </v-col>
            <v-col cols="12">
              <v-divider class="my-3"></v-divider>
            </v-col>
            <v-col cols="6">
              ایمیل :
              {{contact_detail.email}}
            </v-col>
            <v-col cols="6" :style="`color:${contact_detail.is_read?'green':'red'}`">
              وضعیت :
              {{contact_detail.is_read?'خوانده شده':'خوانده نشده'}}
            </v-col>
            <v-col cols="12">
              <v-divider class="my-3"></v-divider>
            </v-col>
            <v-col cols="12">
              متن پیام :
              <p class="text-justify mx-4 mt-2">{{contact_detail.msg}}</p>
            </v-col>
          </v-row>
          <!-- Title -->

        </v-card-text>
        <v-card-actions style="padding: 0 !important;" >
          <v-btn block  large
                 v-if="!contact_detail.is_read"
                 class=" rounded-0 text-bold"
                 @click="set_contact_is_read(contact_detail.id)"
                 color="success"
                 :loading="is_read_btn_loading"
                 :disabled="is_read_btn_loading">
            تغییر وضعیت به خوانده شده
          </v-btn>
          <v-btn block  large
                 v-else
                 class="elevation-0 rounded-0 text-bold"
                 @click="show_detail=false"
                 color="secondary"
          >
            بازگشت
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'HomeManageContacts',
  data:()=>({
    key: localStorage.getItem('key'),
    loading_tickets: false,
    search_field:null,
    contacts_count:0,
    page:1,
    contacts_table: {
      headers: [
        {text: 'نام',align: 'center', value: 'f_name', sortable: false},
        {text: 'نام خانوادگی',align: 'center', value: 'l_name', sortable: false},
        {text: 'ایمیل',align: 'center', value: 'email', sortable: false},
        {text: 'پیام',align: 'center', value: 'msg', sortable: false},
        {text: 'خوانده شده',align: 'center', value: 'is_read'},
      ],
      desserts:[],
    },
    rules: {
      min_3: v => v.length >= 3 || 'حداقل ۳ حرف',
    },
    show_detail:false,
    contact_detail:{},
    is_read_btn_loading:false,
  }),
  created() {
    this.get_contacts();
  },
  methods:{
    handler_click_row(item){
      this.contact_detail=item;
      this.show_detail=true;
    },
    async get_contacts(){
      this.loading_tickets = true;
      try {
        const response = await axios
            .get(`${this.BACKEND_LINK}/api/account-admin/home-contacts/?page=${this.page}${this.search_field?`&search=${this.search_field}`:''}`,{
          headers: {'Authorization': `Token ${this.key}`}
        });
        if (response.data){
          this.contacts_count = response.data.count;
          this.contacts_table.desserts = response.data.results;
        }
      } catch (error) {
        this.$snotify.error(`در دریافت مشکلی به وجود آمد. کد : ${error.response.status}`, 'دریافت اطلاعات');
      } finally {
        this.loading_tickets = false;
      }
    },
    set_contact_is_read(id){
      this.is_read_btn_loading = true;
      axios.put(`${this.BACKEND_LINK}/api/account-admin/home-contacts-read/${id}`, this.task,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.is_read_btn_loading = false;
        if(response.data.status){
          this.$snotify.success(response.data.msg, 'ثبت وضعیت');
          this.contact_detail.is_read=true;
          this.show_detail = false;
        }
      }).catch((error)=>{
      this.is_read_btn_loading = false;
        this.$snotify.error(`در ثبت وضعیت مشکلی به وجد آمد لطفا مجددا تلاش کنید. کد : ${error.response.status}`, 'ثبت وضعیت');
      })
    },

    change_search_field(){
      this.search_items=this.contacts_table.desserts;
    },
  }
}
</script>
